module.exports = __webpack_public_path__ + "img/cargo-wagon-mask-1.ce1369de.png";